import type { RecommendedAccosAPIResponse } from '@/scopes/products/infrastructure/api/recommended-accos/types'
import { AccoListerAcco, Mealplan } from '@/scopes/common/domain/acco-lister/types'
import { mapParticipants } from '@/scopes/common/domain/functions/mapParticipants'

export interface RecommendedAccosResponseMapper {
  map: (apiResponse: RecommendedAccosAPIResponse) => AccoListerAcco[]
}

// TODO: Remove this hardcoded mapping once the API returns the mealplan names
function mapMealplan(mealplanCode: string): Mealplan {
  let name: string

  switch (mealplanCode) {
    case 'LG':
      name = 'Logies'
      break
    case 'LO':
      name = 'Logies ontbijt'
      break
    case 'HP':
      name = 'Halfpension'
      break
    case 'VP':
      name = 'Volpension'
      break
    case 'AI':
      name = 'All-inclusive'
      break
    case 'UA':
      name = 'Ultra all inclusive'
      break
    default:
      name = mealplanCode
      break
  }

  return {
    code: mealplanCode,
    name,
  }
}

export const createRecommendedAccosResponseMapper: () => RecommendedAccosResponseMapper = () => {
  function map({ results: data }: RecommendedAccosAPIResponse): AccoListerAcco[] {
    if (!data) {
      return []
    }

    return data.filter(item => item.image).map<AccoListerAcco>((item) => {
      const mappedItem: AccoListerAcco = {
        id: item.accommodationId,
        name: item.name,
        imageUrl: item.image!,
        rating: item.rating,
        city: item.cityName,
        region: item.regionName,
        country: item.countryName,
        url: item.url,
        price: {
          averagePrice: item.price.averagePrice,
          currencySettings: {
            symbol: item.price.currencySettings.symbol,
            symbolPosition: item.price.currencySettings.symbolPosition,
            numberOfDecimals: item.price.currencySettings.numberOfDecimals,
          },
          includedServices: { ...item.price.includedServices },
          staticText: item.price.staticText,
          departureDate: item.price.acmInformation?.departureDateRaw,
          durationInDays: item.price.acmInformation?.durationRaw,
          mealplan: mapMealplan(item.price.acmInformation?.mealplanCode ?? ''),
          transportType: item.price.acmInformation?.transportType,
          participants: mapParticipants(item.price.acmInformation?.birthdates ?? []),
          showAcmInformation: !!item.price.acmInformation,
        },
        userRating: item.userRating,
        usps: item.usps,
        campaign: item.campaign,
        locations: item.locations,
      }

      if (item.price.priceDiscounts) {
        mappedItem.price.discount = {
          percentage: item.price.priceDiscounts.discountPercentage,
          originalPrice: item.price.priceDiscounts.originalPrice,
        }
      }

      if (item.collection) {
        mappedItem.collection = {
          id: item.collection.id,
          name: item.collection.name,
        }
      }

      return mappedItem
    })
  }

  return { map }
}
